import React from 'react';
import { connect } from 'react-redux';
import RoleSectionComponent from './RoleSectionComponent';
import roleOperations from './duck/operations';
import { appOperations } from 'App/duck';

const mapStateToProps = ({
    appReducer,
    locationReducer,
}) => {
  return {
    roles: appReducer.roles.data,
    locationId: locationReducer.location_code,
  };
};

const mapDispatchToProps = (dispatch) => {
  const loadLocationRolesDispatch = (locationId) => {
    dispatch(appOperations.fetchLocationRolesOperation(locationId));
  }

  const deleteRoleDispatch = (tagId, locationId) => {
    dispatch(roleOperations.deleteRoleOperation(tagId, locationId));
  }

  const addRoleDispatch = (roleName, colorCode, locationId) => {
    dispatch(roleOperations.addRoleOperation(roleName, colorCode, locationId));
  }

  const updateRoleDispatch = (roleId, colorCode, locationId) => {
    dispatch(roleOperations.updateRoleOperation(roleId, colorCode, locationId));
  }

  return {
    loadLocationRolesDispatch,
    deleteRoleDispatch,
    addRoleDispatch,
    updateRoleDispatch,
  };
};

const RoleSectionContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => {
  const {
    roles,
    locationId,
    loadLocationRolesDispatch,
    deleteRoleDispatch,
    addRoleDispatch,
    updateRoleDispatch,
    selectedRoleId,
    onSelectRole,
    members,
  } = props;

  return <RoleSectionComponent
    roles={roles}
    locationId={locationId}
    loadLocationRolesDispatch={loadLocationRolesDispatch}
    deleteRoleDispatch={deleteRoleDispatch}
    addRoleDispatch={addRoleDispatch}
    updateRoleDispatch={updateRoleDispatch}
    selectedRoleId={selectedRoleId}
    onSelectRole={onSelectRole}
    members={members}
    {...props}
  />
});

export default RoleSectionContainer;

